export default __webpack_public_path__ + "static/media/tramo-home-trend.5db752f4.svg";